import { ReactNode } from 'react'
import { useHover } from '@react-aria/interactions'
import { Button } from 'blaze-ui/Button/Button'
import Styles from './ExampleCard.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'
import { LinkExternal } from 'blaze-ui/icons'

interface ExampleCardProps {
  logo?: ReactNode
  onSelect: (value: string) => void
  text: string
  url?: string
}

export const ExampleCard = ({ logo, text, url, onSelect }: ExampleCardProps) => {
  const { hoverProps, isHovered } = useHover({})

  const handleSelectLogo = () => {
    if (!url) return
    onSelect(url)
  }

  const handleSelectText = () => {
    onSelect(text)
  }

  if (!!logo) {
    return (
      <div className={cx(Styles.exampleCard, { [Styles.hover]: isHovered })} {...hoverProps} onClick={handleSelectLogo}>
        {!!url && (
          <div className={Styles.linkContainer}>
            <ButtonLink to={url} variant="secondary" size="xs" frontIcon={LinkExternal} target="_blank" />
          </div>
        )}
        <div className={Styles.buttonContainer}>
          <Button variant="secondary" size="sm" onPress={handleSelectLogo}>
            Use This Example
          </Button>
        </div>
        <div className={Styles.logoContainer}>{logo}</div>
        <Text variant="smallList">{text}</Text>
      </div>
    )
  }

  return (
    <div className={cx(Styles.exampleCard, { [Styles.hover]: isHovered })} {...hoverProps}>
      <div className={Styles.hoverContainer} onClick={handleSelectText}>
        <div className={Styles.buttonContainer}>
          <Button variant="secondary" size="md" onPress={handleSelectText}>
            Copy Text
          </Button>
        </div>
        <div className={Styles.text}>{text}</div>
      </div>
    </div>
  )
}
